import { useGetGroupsSuspense } from '@uturn/api/v1';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ShipmentGroupsPage } from '../../layouts';

export function GroupedShipments() {
	const { t } = useTranslation();
	const [page, setPage] = useState(0);

	const { data: groups, queryKey: groupsQueryKey } = useGetGroupsSuspense(
		// @ts-expect-error: Fix GetGroupsParams in Java from { pageable: Pageable } to Pageable.
		{ page },
		{ query: { select: (data) => data.data } },
	);

	return (
		<>
			<Helmet
				title={t(
					'pages.shipments.grouped.title',
					'Grouped shipments',
				).toString()}
			/>
			<ShipmentGroupsPage
				// @ts-expect-error: Fix GetGroupsParams in Java from { pageable: Pageable } to Pageable.
				data={groups}
				page={page}
				groupsQueryKey={groupsQueryKey}
				setPage={setPage}
			/>
		</>
	);
}
